webpackJsonp([115148276582802],{

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(65);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(53);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactLoadScript = __webpack_require__(330);
	
	var _reactLoadScript2 = _interopRequireDefault(_reactLoadScript);
	
	var _graphql = __webpack_require__(73);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InterviewsPage = function (_React$Component) {
	  _inherits(InterviewsPage, _React$Component);
	
	  function InterviewsPage() {
	    _classCallCheck(this, InterviewsPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  InterviewsPage.prototype.handleScriptLoad = function handleScriptLoad() {
	    if (typeof window !== 'undefined' && window.netlifyIdentity) {
	      window.netlifyIdentity.on('init', function (user) {
	        if (!user) {
	          window.netlifyIdentity.on('login', function () {
	            document.location.href = '/admin/';
	          });
	        }
	      });
	    }
	    window.netlifyIdentity.init();
	  };
	
	  InterviewsPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var data = this.props.data;
	    var posts = data.allMarkdownRemark.edges;
	
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'interviews' },
	      _react2.default.createElement(_reactLoadScript2.default, {
	        url: 'https://identity.netlify.com/v1/netlify-identity-widget.js',
	        onLoad: function onLoad() {
	          return _this2.handleScriptLoad();
	        }
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'has-text-weight-bold is-size-2' },
	            'Latest Interviews'
	          )
	        ),
	        posts.filter(function (post) {
	          return post.node.frontmatter.templateKey === 'interview-post';
	        }).map(function (_ref) {
	          var post = _ref.node;
	          return _react2.default.createElement(
	            'div',
	            { className: 'content interview-preview', key: post.id },
	            _react2.default.createElement(_gatsbyImage2.default, {
	              className: 'img-preview',
	              alt: post.frontmatter.title,
	              sizes: post.frontmatter.featuredImage.childImageSharp.sizes
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'text' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { className: 'post-link', to: post.frontmatter.path },
	                  post.frontmatter.title
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'small',
	                  null,
	                  post.frontmatter.date
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                post.frontmatter.description,
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  {
	                    className: 'button is-small',
	                    to: post.frontmatter.path
	                  },
	                  'Keep Reading \u2192'
	                )
	              )
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return InterviewsPage;
	}(_react2.default.Component);
	
	exports.default = InterviewsPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-interviews-index-js-188c51091dd29fc6e77f.js